import styled from "styled-components";

import {ArticleSectionContainer} from "./ArticleSectionContainer";

export const HideInPrintContent = styled(ArticleSectionContainer)`
  @media print {
    display: none;
  }
`;